import { render } from "./incomingMaterial.vue?vue&type=template&id=54e3f589&scoped=true"
import script from "./incomingMaterial.vue?vue&type=script&lang=js"
export * from "./incomingMaterial.vue?vue&type=script&lang=js"

import "./incomingMaterial.vue?vue&type=style&index=0&id=54e3f589&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e3f589"]])

export default __exports__